const TYPE_MAP: {
  [type_of: string]: string;
} = {
  read: 'trigger',
  write: 'action',
  filter: 'action',
  search: 'search',
  search_or_write: 'search',
};

export const getActionType = (inputType?: string) => {
  if (!inputType) {
    return inputType;
  }
  if (TYPE_MAP[inputType]) {
    return TYPE_MAP[inputType];
  }
  if (Object.values(TYPE_MAP).includes(inputType)) {
    return inputType;
  }
  return undefined;
};

export default getActionType;
